<div class="o-grid o-grid--center-v">
	<div class="o-grid__cell">
		<div *ngIf="!vm.ratingGiven">
			<h1 class="c-text c-text--heading c-text--s6 c-text--lg">{{'PreVisit.Feedback.Give_Us_Feedback' | translate}}</h1>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-no-p u-ost-sm">
				<button id="positiveRatingButton" type="button" class="c-button c-button--s6 c-button--lg c-button--fit@up-to-sm u-osb-md u-osr-md" (click)="vm.giveRating(1)" style="align-items:center;display: inline-flex;justify-content: center;">
					<img style="width:24px;height:24px;" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icon_thumbs_up.svg" title="{{'PreVisit.Feedback.Positive' | translate}}" />
				</button>
				<button id="negativeRatingButton" type="button" class="c-button c-button--s6 c-button--lg c-button--fit@up-to-sm" (click)="vm.giveRating(0)" style="align-items:center;display: inline-flex;justify-content: center;">
					<img style="width:24px;height:24px;" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/icon_thumbs_down.svg" title="{{'PreVisit.Feedback.Negative' | translate}}" />
				</button>
			</div>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-no-p" *ngIf="vm.ratingGiven && !vm.commentGiven">
			<h1 id="thankYouForRatingLabel" class="c-text c-text--heading c-text--s6 c-text--lg">{{'PreVisit.Feedback.Thank_You_For_Rating' | translate}}</h1>
			<p class="c-text u-ost-sm">{{'PreVisit.Feedback.If_You_Have_A_Comment' | translate}}</p>
			<div class="o-grid u-ost-md">
				<div class="o-grid__cell o-grid__cell--center-v u-no-p">
					<form class="c-form">
						<div class="c-form__group u-no-m">
							<textarea id="feedbackCommentInput" name="feedbackCommentInput" class="c-form__input c-form__input--sm"
								placeholder="{{ 'PreVisit.Feedback.Write_Comment' | translate}}" rows="2"
								maxlength="254" [(ngModel)]="vm.comment" (keyup)="vm.handleKeyup($event)">
							</textarea>
						</div>
					</form>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v u-no-p" *ngIf="vm.comment?.length">
					<button id="submitFeedbackCommentButton" type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md" (click)="vm.sendComment()" [disabled]="vm.loading">
						<i class="o-icon o-icon--send c-text c-text--main c-text--lg u-no-mr" aria-hidden="true" title="{{ 'Common.Send' | translate }}"></i>
						<span class="u-sr-only">{{ 'Common.Send' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-no-p" *ngIf="vm.ratingGiven && vm.commentGiven">
			<h1 id="thankYouForCommentLabel" class="c-text c-text--heading c-text--s6 c-text--lg">{{'PreVisit.Feedback.Thank_You_For_Comment' | translate}}</h1>
		</div>
	</div>
</div>
